import React, {useEffect, useState} from "react";
import tw from "twin.macro";
import {useParams} from "react-router-dom";

import Head from "components/headers/light";
import Footer from "components/Footer.js";
import UserReviewInputAndList from "components/UserReviewInputAndList.js";
import Gallery from "components/Gallery.js";
import {useAppDispatch, loadActress, loadMoreGallery, loadGallery, useAppSelector} from "../../../redux";
import ReadMoreButton from "components/ReadMoreButton";
import {SocialShareButton} from "components/SocialShareButton";
import AdComponent from '../../../components/AdComponent.js';
const Row = tw.div`md:flex lg:flex-row border-2 pt-8 lg:pt-5 max-w-screen-xl mx-auto `;
const TextColumn = tw.div` bg-gray-800 p-5`;
const Description = tw.text`lg:text-sm text-gray-300 w-64 my-auto my-1`;
const Image = tw.img`h-96 w-full object-cover bg-blue-200`;
const MainText = tw.div`flex`;
const H1 = tw.text`pt-1 w-48 lg:text-sm text-gray-500`;
const Rating = tw.div`py-5 bg-white w-full flex justify-start `;
const RowColum = tw.div`bg-gray-800 w-full md:w-72 mt-20`;
const Div = tw.div``;
const MovieContent = tw.div`bg-white px-5 mt-5 md:mt-20`;
const Flex = tw.div`flex mx-5 items-center`;
const HeadText = tw.h1`lg:text-2xl md:text-xl text-lg text-gray-900 font-bold py-2`;
const TextContent = tw.h1`text-sm text-gray-800 leading-7 font-semibold py-2`;
const DivRoot = tw.div`w-full  mx-auto px-5 xsm:py-2 lg:py-4 z-50 fixed bg-white`;
const Text = tw.h1`mx-2 text-lg text-gray-800 font-semibold justify-center`;
const Hr = tw.hr`mt-2`;

function ImageGallery({match}) {
  const id = useParams();
  const dispatch = useAppDispatch();
  const [footerShow, setFooterShow] = useState("");


  const actressRef = useAppSelector(state => state.actress.actress);
  const gallery = useAppSelector(state => state.gallery.gallery);
  const isEndReached = useAppSelector(state => state.gallery.isEndReached);
  const actressId = actressRef.filter(item => item.id === id.id);
  const actress = actressId[0];

  useEffect(() => {
    if (actressRef.length !== 0) {
      dispatch(loadGallery(actress.name));
    }
  }, [actressRef.length, dispatch]);
  useEffect(() => {
    if (actressRef.length <= 0) {
      dispatch(loadActress());
    }
  }, [dispatch]);
  const handleLoadMoreData = () => {
    dispatch(loadMoreGallery(actress.name));
  };


  return (
    <>
      <DivRoot>

        <Head />
        <Hr />
      </DivRoot>
      <AdComponent />
      {actress && <div key={actress.id}>
        <Row>
          <RowColum>
            <Image src={actress.cover_url} />
            <TextColumn>
              <Div>
                <MainText>
                  <H1>Actor Name:</H1>
                  <Description>{actress.name}</Description>
                </MainText>
                <MainText>
                  <H1>Birth Name:</H1>
                  <Description>{actress.birth_name}</Description>
                </MainText>
                <MainText>
                  <H1>Birth Date:</H1>
                  <Description>{actress.birth_date}</Description>
                </MainText>
                {actress.death_date.length > 0 && <MainText>
                  <H1>Death Date:</H1>
                  <Description>{actress.death_date}</Description>
                </MainText>}
                {actress.alma_master.length > 0 && <MainText>
                  <H1>Alma mater:</H1>
                  <Description>{actress.alma_master}</Description>
                </MainText>}

                <MainText>
                  <H1>Years active:</H1>
                  <Description>{actress.years_of_active}</Description>
                </MainText>

                {actress.children.length > 0 && <MainText>
                  <H1>Children:</H1>
                  <Description>{actress.children}</Description>
                </MainText>}

                {actress.notable_works.length > 0 && <MainText>
                  <H1>Notable Works:</H1>
                  <Description>{actress.notable_works}</Description>
                </MainText>}

                {actress.spouse.length > 0 && <MainText>
                  <H1>Spouse:</H1>
                  <Description>{actress.spouse}</Description>
                </MainText>}

              </Div>

            </TextColumn>
          </RowColum>
          <div>
            <MovieContent>
              <HeadText>Biography</HeadText>
              <TextContent>{actress.biography}</TextContent>
            </MovieContent>
            <hr />
            <Rating>
              {/* <Flex>
                {like ? (
                  <img
                    width="20"
                    onClick={() => LikeCountM()}
                    src={require("../../../images/flximg/likecolor.svg")} />
                ) : (
                  <img
                    width="20"
                    onClick={() => LikeCountP()}
                    src={require("../../../images/flximg/like.svg")}
                  />
                )}

                <Text>{actress.like || 0}</Text>

              </Flex> */}
              <SocialShareButton />
              {/* <Flex>
                   <Text>Gallery</Text> 
                   <Like>Share</Like> 
                  <a href={"https://www.youtube.com/watch?v=yg-YY8HYzT8"} target="_blank">
                  <ShareLink src={"https://upload.wikimedia.org/wikipedia/commons/5/51/Facebook_f_logo_%282019%29.svg"} />
                  </a>
                  <ShareLink src={"https://cdnlogo.com/logos/t/96/twitter-icon.svg"} />
                </Flex> */}
            </Rating>
            <hr />
            <UserReviewInputAndList id={id.id} />
          </div>
        </Row>
        <Gallery gallery={gallery} />
        {gallery.length === 0 || isEndReached ? null : <ReadMoreButton handleLoadMoreData={handleLoadMoreData} />}
        <Footer />
      </div>}


      {footerShow ? <Footer /> : <></>}

    </>

  );
}

export default ImageGallery;


{/* <Root>
  <One>
    {/* {actressInfo.map((actressInfo)=>( <div key={actressInfo.id}> 
    <TextInfo>Info</TextInfo>
    {actressInfo.actressName === "" ? null :
      <div>
        <FlexOne>
          <TextOne>Name</TextOne>
          <TextOne>:{actressInfo.actressName}</TextOne>
        </FlexOne>
      </div>}
    {actressInfo.birthName === "" ? null :
      <div>
        <FlexOne>
          <TextOne>Birth Name</TextOne>
          <TextOne>:{actressInfo.birthName}</TextOne>
        </FlexOne>
      </div>}
    {actressInfo.birthInfo === "" ? null :
      <div>
        <FlexOne>
          <TextOne>Birth Info</TextOne>
          <TextOne>:{actressInfo.birthInfo}</TextOne>
        </FlexOne>
      </div>}
    {actressInfo.almamater === "" ? null :
      <div>
        <FlexOne>
          <TextOne>Alma mater</TextOne>
          <TextOne>:{actressInfo.almamater}</TextOne>
        </FlexOne>
      </div>}
    {actressInfo.yearsActive === "" ? null :
      <div>
        <FlexOne>
          <TextOne>Years Active</TextOne>
          <TextOne>:{actressInfo.yearsActive}</TextOne>
        </FlexOne>
      </div>}
    {actressInfo.spouse === "" ? null :
      <div>
        <FlexOne>
          <TextOne>Spouse</TextOne>
          <TextOne>:{actressInfo.spouse}</TextOne>
        </FlexOne>
      </div>}
    {actressInfo.children === "" ? null :
      <div>
        <FlexOne>
          <TextOne>Children</TextOne>
          <TextOne>:{actressInfo.children}</TextOne>
        </FlexOne>
      </div>}
     </div>))} 
    {actressImages.map((actressInfo) => (
      <ImageContainer key={actressInfo.id}>
        <Image src={actressInfo.image} />
        <Flex></Flex>
      </ImageContainer>
    ))}
  </One>
  <Two>
    <Text>Latest Gallery</Text>
    {actressMainImages && actressMainImages.slice(0, 4).map((actressInfo) => (
      <Div key={actressInfo.id}>
        <a onClick={() => {window.location.href = `/gallery/${actressInfo.id}`;}}> <ImageRight src={actressInfo.actressImage} /></a>
      </Div>
    ))}
  </Two>
</Root>; */}